module.exports = __webpack_public_path__ + "static/media/devops.0ed31b2e.png";